/* LH Theme — global.js */
(function () {
  'use strict';

  /* ---------- Mobile drawer ---------- */
  var drawer = document.querySelector('[data-drawer]');
  document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (drawer) {
        drawer.hidden = false;
        document.body.style.overflow = 'hidden';
      }
    });
  });
  if (drawer) {
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        drawer.hidden = true;
        document.body.style.overflow = '';
      });
    });
  }

  /* ---------- Header search toggle ---------- */
  var searchBar = document.querySelector('[data-search-bar]');
  document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (!searchBar) return;
      e.preventDefault();
      searchBar.hidden = !searchBar.hidden;
      if (!searchBar.hidden) {
        var input = searchBar.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  });

  /* ---------- Hero slider ---------- */
  document.querySelectorAll('[data-slider]').forEach(function (slider) {
    var slides = slider.querySelectorAll('[data-slide]');
    if (slides.length < 2) return;

    var dots = slider.querySelectorAll('[data-slide-to]');
    var current = 0;
    var autoplaySeconds = parseInt(slider.dataset.autoplay, 10) || 0;
    var timer = null;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function startAutoplay() {
      if (autoplaySeconds > 0) {
        clearInterval(timer);
        timer = setInterval(function () { goTo(current + 1); }, autoplaySeconds * 1000);
      }
    }

    var prev = slider.querySelector('[data-slider-prev]');
    var next = slider.querySelector('[data-slider-next]');
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); startAutoplay(); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); startAutoplay(); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.slideTo, 10));
        startAutoplay();
      });
    });

    slider.addEventListener('mouseenter', function () { clearInterval(timer); });
    slider.addEventListener('mouseleave', startAutoplay);
    startAutoplay();
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrap = (minus || plus).closest('.quantity');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var value = parseInt(input.value, 10) || 0;
    var min = parseInt(input.min, 10);
    if (isNaN(min)) min = 1;
    input.value = plus ? value + 1 : Math.max(min, value - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product gallery thumbnails ---------- */
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    var mainImage = gallery.querySelector('[data-main-image]');
    gallery.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImage) return;
        mainImage.src = thumb.dataset.full;
        gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---------- Variant picker ---------- */
  var productJsonEl = document.querySelector('[data-product-json]');
  var optionSelects = document.querySelectorAll('[data-option-select]');
  if (productJsonEl && optionSelects.length) {
    var productData;
    try { productData = JSON.parse(productJsonEl.textContent); } catch (err) { productData = null; }

    if (productData) {
      var formatMoney = function (cents) {
        var amount = (cents / 100).toFixed(2);
        var parts = amount.split('.');
        // Indian-style grouping falls back gracefully for other locales
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return window.Shopify && window.Shopify.currency
          ? parts.join('.') + ' ' + window.Shopify.currency.active
          : parts.join('.');
      };

      var updateVariant = function () {
        var selected = [];
        optionSelects.forEach(function (sel) {
          selected[parseInt(sel.dataset.optionPosition, 10) - 1] = sel.value;
        });

        var variant = productData.variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });

        var idInput = document.querySelector('[data-variant-id]');
        var addBtn = document.querySelector('[data-add-to-cart]');
        if (!variant) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
          return;
        }

        if (idInput) idInput.value = variant.id;
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
        }

        // Update price display
        var priceWrap = document.querySelector('.product-page__details .price');
        if (priceWrap) {
          var currentEl = priceWrap.querySelector('.price__current');
          var compareEl = priceWrap.querySelector('.price__compare');
          if (currentEl) currentEl.textContent = formatMoney(variant.price);
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceWrap.classList.add('price--on-sale');
            if (compareEl) compareEl.textContent = formatMoney(variant.compare_at_price);
          } else {
            priceWrap.classList.remove('price--on-sale');
            if (compareEl) compareEl.textContent = '';
          }
        }

        // Update main image if the variant has one
        if (variant.featured_image && variant.featured_image.src) {
          var mainImg = document.querySelector('[data-main-image]');
          if (mainImg) mainImg.src = variant.featured_image.src;
        }

        // Reflect variant in URL
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      };

      optionSelects.forEach(function (sel) {
        sel.addEventListener('change', updateVariant);
      });

      document.querySelectorAll('[data-option-value]').forEach(function (button) {
        button.addEventListener('click', function () {
          var position = button.dataset.optionPosition;
          var select = document.querySelector('[data-option-select][data-option-position="' + position + '"]');
          if (!select) return;
          select.value = button.dataset.optionValue;
          document.querySelectorAll('[data-option-value][data-option-position="' + position + '"]').forEach(function (optionButton) {
            var selected = optionButton === button;
            optionButton.classList.toggle('is-selected', selected);
            optionButton.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }
  }

  /* ---------- Collection sorting ---------- */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Cart: auto-submit on quantity change ---------- */
  var cartForm = document.querySelector('.cart-form');
  if (cartForm) {
    var debounce;
    cartForm.querySelectorAll('.quantity input').forEach(function (input) {
      input.addEventListener('change', function () {
        clearTimeout(debounce);
        debounce = setTimeout(function () {
          var updateBtn = cartForm.querySelector('button[name="update"]');
          if (updateBtn) updateBtn.click();
        }, 500);
      });
    });
  }
})();
